import _ from 'lodash';
import BaseEmitter from 'tiny-emitter';

const scopeEvent = (controllerId, event) => `${controllerId}_${event}`;
class Emitter {
  constructor() {
    this.emitter = new BaseEmitter();
  }

  createScopedEmitter(controllerId) {
    // adds a controller id to the name of the event.
    const boundFunc = (func) => ({ [func]: this[func].bind(this, controllerId) });

    return ['on', 'off', 'once', 'fireEvent'].reduce((acc, funcName) => _.assign(acc, boundFunc(funcName)), {});
  }

  on(controllerId, event, callback, context) {
	  const scopedEvent = scopeEvent(controllerId, event);
    this.emitter.on(scopedEvent, callback, context);
    return () => this.emitter.off(scopedEvent, callback);
  }

  once(controllerId, event, callback, context) {
	  const scopedEvent = scopeEvent(controllerId, event);
    this.emitter.once(scopedEvent, callback, context);
    return () => this.emitter.off(scopedEvent, callback);
  }

  off(controllerId, event, callback) {
    this.emitter.off(scopeEvent(controllerId, event), callback);
  }

  fireEvent(controllerId, event, ...args) {
    this.emitter.emit(scopeEvent(controllerId, event), ...args);
  }
}

export default Emitter;
